import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { useEffect, useMemo, useState } from "react"
import { InputModel } from "../../../../../utils/types"
import { daysOfWeek, frequencies, inputOneDaily, inputOneWeekly, inputSecondCycli, inputSecondDaily, today } from "../../../../calendar/pages/form/constans/inputs"
import { FrequencyEnum } from "../../../../calendar/pages/form/components/steps/configCalendar/enums"
import { DateModalRange } from "../../../../../components/dinamicForm/dateModal"
import { FrecuencyInput } from "../../../../calendar/pages/form/components/steps/frecuencyInput"
import { Constants } from "../../../../../utils/constants"
import { Box, Button, Drawer, FormControlLabel, Typography } from "@mui/material"
import dayjs from "dayjs"
import { itemTypeScheduling } from "../../../../calendar/pages/form/components/steps/configCalendar/methods"
import { IOSSwitch } from "../../../../../components/dynamicFormRef/switch"
import SelectActionPlan from "../../../../actionPlans/pages/main/components/selectActionPlan"
import { CustomSelect } from "../../../../../components"
import { icons } from "../../../../../utils/icons"
import SimpleModal from "../../../../../components/modal/simpleModal"
import { PropsConfigUser } from "./types"
import { toUnitTimeZone } from "../../../../../utils/methods/calcDate"
import MultiSelectSimple from "../../../../../components/dinamicForm/multiSelectSimple"
import { DaysWeek } from "../../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs"
import { eachDayOfInterval } from "date-fns"
import MapMarker from '../../../../../assets/svg/mapMarker.svg'


const UserScheduleConfig = ({ onChange, flag, setFlag, setErrors, userSelectes, items, loadings, selectedDays, children, childrenRef, setChildren, setData, setSelectedDays, setStartDate, data, errors, mimTimeZone, refRange, disabled, handleCloseScheduleUser, keepSaveSchedule, open, startDate }: PropsConfigUser) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const [modal, setModal] = useState<{
        open: boolean
        description: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        description: t('schedule.modal.saveConfiguration'),
        confirm: () => { }
    })

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const [inputSecondWeekly, setInputSecondWeekly] = useState<{ [x: string]: InputModel }>({
        dayOfWeek: {
            label: 'general.tags.each',
            translate: true,
            name: 'dayOfWeek',
            type: 'select',
            value: null,
            items: daysOfWeek,
            rest: {
                max: 'to',
            },
            validate: {
                required: true,
            },
            size: {
                xl: 12,
                lg: 12,
                md: 12,
                sm: 12,
            },
            wrapChildren: ({ children, id }) => {
                return (<>
                    <Box sx={{ minHeight: '70px', alignContent: 'center' }}>
                        <Box sx={{
                            '& .MuiInputBase-root': {
                                height: '70px',
                            },
                            '& .MuiFormLabel-root': {
                                top: '8px'
                            }
                        }}>{children}</Box>
                    </Box>
                </>
                )
            }
        },
    })

    const getFrecuencyInputs = () => {
        let caseFrequency = <></>
        switch (data.frequency) {
            case FrequencyEnum.CYCLIC:
                caseFrequency =
                    <FrecuencyInput
                        endDateName="endDate"
                        endDateNameButton={t('general.tags.closingTime')}
                        endFromName="toDateCycli"
                        endFromNameButton={t('general.tags.to')}
                        startDateName="startDate"
                        startDateNameButton={t('general.tags.openingTime')}
                        startFromName="fromDateCycli"
                        startFromNameButton={t('general.tags.from')}
                        mimTimeZone={mimTimeZone}
                        refRange={refRange}
                        startDate={startDate}
                        selectedsDays={selectedDays}
                        setSelectedDays={setSelectedDays}
                        type={data.frequency}
                        data={data}
                        errors={errors}
                        input={inputOneWeekly}
                        inputSecond={inputSecondCycli}
                        onChange={onChange}
                    />
                break
            case FrequencyEnum.DAYLI:
                caseFrequency =
                    <FrecuencyInput
                        endDateName="endDateDaily"
                        endDateNameButton={t('general.tags.endHour')}
                        endFromName="toDateDaily"
                        endFromNameButton={t('general.tags.from')}
                        startDateName="startDateDaily"
                        startDateNameButton={t('general.tags.initHour')}
                        startFromName="fromDateDaily"
                        startFromNameButton={t('general.tags.from')}
                        mimTimeZone={mimTimeZone}
                        refRange={refRange}
                        startDate={startDate}
                        selectedsDays={selectedDays}
                        setSelectedDays={setSelectedDays}
                        type={data.frequency}
                        data={data}
                        errors={errors}
                        input={inputOneDaily}
                        inputSecond={inputSecondDaily}
                        onChange={onChange}
                    />
                break
            case FrequencyEnum.UNIQUE:
                caseFrequency = <Box sx={{ marginBottom: 1, paddingLeft: '4px', paddingRight: '4px' }}>
                    <DateModalRange
                        mimTimeZone={mimTimeZone ?? Constants.defaultTimeZoneObject}
                        defaultErrors={{ from: errors?.from, to: errors?.to }}
                        setDate={(payload) => {
                            onChange({
                                target: {
                                    name: payload.target.name,
                                    value: payload.target.value,
                                }
                            })
                        }}
                        from={data.from}
                        to={data.to ?? null}
                        ref={refRange}
                    />
                </Box>
                break
            case FrequencyEnum.WEEKLY:
                caseFrequency =
                    <FrecuencyInput
                        endDateName="endDate"
                        endDateNameButton={t('general.tags.closingTime')}
                        endFromName="toDateWeekly"
                        endFromNameButton={t('general.tags.to')}
                        startDateName="startDate"
                        startDateNameButton={t('general.tags.openingTime')}
                        startFromName="fromDateWeekly"
                        startFromNameButton={t('general.tags.from')}
                        mimTimeZone={mimTimeZone}
                        refRange={refRange}
                        startDate={startDate}
                        selectedsDays={selectedDays}
                        setSelectedDays={setSelectedDays}
                        type={data.frequency}
                        data={data}
                        errors={errors}
                        input={inputOneWeekly}
                        inputSecond={inputSecondWeekly}
                        onChange={onChange} />
                break
            default:
                caseFrequency = <></>
        }

        return caseFrequency
    }

    const formatSelectedDays = (selectedDays: number[]): string => {
        const labels = daysOfWeek
            .filter(day => selectedDays.includes(day.value))
            .map(day => day.label);

        if (labels.length === 0) return '';
        if (labels.length === 1) return labels[0];
        if (labels.length === 2) return `${labels[0]} y ${labels[1]}`;

        const allButLast = labels.slice(0, -1).join(', ');
        const last = labels[labels.length - 1];
        return `${allButLast} y ${last}`;
    };

    const assignedChildren = () => {
        let newChilds: string[] = [];
        if (!!data.openQuestionnaire) {
            newChilds = [
                t('schedule.assigned.freeScheduling')
            ];

        } else {
            if (data.frequency == FrequencyEnum.UNIQUE) {
                const fechaFrom = dayjs(data.from).format(Constants.dayjsFormatDate);
                const horaFrom = dayjs(data.from).format(Constants.dayjsFormatTime);
                const parsedHoraFrom = dayjs(horaFrom, 'hh:mm A');
                const horaFromParse = parsedHoraFrom.hour() % 12 || 12;
                const isHoraFromOne = horaFromParse === 1;
                const fechaTo = dayjs(data.to).format(Constants.dayjsFormatDate);
                const horaTo = dayjs(data.to).format(Constants.dayjsFormatTime);
                const parsedHoraTo = dayjs(horaTo, 'hh:mm A');
                const horaToParse = parsedHoraTo.hour() % 12 || 12;
                const isHoraToOne = horaToParse === 1;
                newChilds = [
                    t('schedule.assigned.singlSscheduling'),
                    isHoraFromOne && isHoraToOne ?
                        t('schedule.assigned.availablefromOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                        :
                        isHoraFromOne && !isHoraToOne ?
                            t('schedule.assigned.availablefromOnlyOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                            :
                            !isHoraFromOne && isHoraToOne ?
                                t('schedule.assigned.availablefromOnlyTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                :
                                t('schedule.assigned.availablefromTow', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                ];
            }

            if (data.frequency == FrequencyEnum.DAYLI) {
                const fechaFrom = dayjs(data.fromDateDaily).format(Constants.dayjsFormatDate);
                const horaFrom = dayjs(data.startDateDaily).format(Constants.dayjsFormatTime);
                const fechaTo = dayjs(data.toDateDaily).format(Constants.dayjsFormatDate);
                const horaTo = dayjs(data.endDateDaily).format(Constants.dayjsFormatTime);
                const days = formatSelectedDays(selectedDays);

                const parsedHoraFrom = dayjs(horaFrom, 'hh:mm A');
                const horaFromParse = parsedHoraFrom.hour() % 12 || 12;
                const isHoraFromOne = horaFromParse === 1;
                const parsedHoraTo = dayjs(horaTo, 'hh:mm A');
                const horaToParse = parsedHoraTo.hour() % 12 || 12;
                const isHoraToOne = horaToParse === 1;
                newChilds = [
                    t('schedule.assigned.dailyScheduling'),
                    isHoraFromOne && isHoraToOne ?
                        t('schedule.assigned.availableEveryDayFromOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                        :
                        isHoraFromOne && !isHoraToOne ?
                            t('schedule.assigned.availableEveryDayFromOnlyOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                            :
                            !isHoraFromOne && isHoraToOne ?
                                t('schedule.assigned.availableEveryDayFromOnlyTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                :
                                t('schedule.assigned.availableEveryDayFromTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo }),
                    t('schedule.assigned.generatedEvery', { days: days }),
                    t('schedule.assigned.initialGeneration', { startDate: fechaFrom, endDate: fechaTo })
                ];
            }

            if (data.frequency == FrequencyEnum.WEEKLY) {
                const fechaFrom = dayjs(data.fromDateWeekly).format(Constants.dayjsFormatDate);
                const fechaTo = dayjs(data.toDateWeekly).format(Constants.dayjsFormatDate);
                const days = formatSelectedDays(selectedDays);
                const dayNumber = Number(data.duration.replace(/\D/g, ''));
                const fechaFromDate = dayjs(data.fromDateWeekly).toDate();
                const fechaToDate = dayjs(data.toDateWeekly).toDate();
                const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
                const arrayDays = eachDayOfInterval({
                    start: fechaFromDate,
                    end: fechaToDate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                const dayLetter = daysOfWeek
                    .filter(day => day.value == data.dayOfWeek)
                    .map(day => day.label);
                newChilds = [
                    t('schedule.assigned.weeklyScheduling'),
                    t('schedule.assigned.eachSchedulingAvailableDuring', { count: dates.length, dayAvailable: dates.length, days: days }),
                    t('schedule.assigned.generatedEveryFrom', { day: dayLetter, startDate: fechaFrom, endDate: fechaTo })
                ];
            }

            if (data.frequency == FrequencyEnum.CYCLIC) {
                const fechaFrom = dayjs(data.fromDateCycli).format(Constants.dayjsFormatDate);
                const fechaTo = dayjs(data.toDateCycli).format(Constants.dayjsFormatDate);
                const days = formatSelectedDays(selectedDays);
                const dayNumber = Number(data.duration.replace(/\D/g, ''));
                const fechaFromDate = dayjs(data.fromDateCycli).toDate();
                const fechaToDate = dayjs(data.toDateCycli).toDate();
                const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
                const arrayDays = eachDayOfInterval({
                    start: fechaFromDate,
                    end: fechaToDate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                newChilds = [
                    t('schedule.assigned.cyclicalScheduling'),
                    t('schedule.assigned.eachSchedulingAvailableDuring', { count: dates.length, dayAvailable: dates.length, days: days }),
                    t('schedule.assigned.generatedConsecutively', { startDate: fechaFrom, endDate: fechaTo })
                ];
            }
        }
        childrenRef.current = !!data.openQuestionnaire ? ['', ...newChilds] : newChilds;
        setChildren(newChilds)
        if (!data.openQuestionnaire && data.from && dayjs(data.from).startOf('minute').isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).startOf('minute')) /* dayjs(data.from).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value))) */) {
            let errorMessage = t('general.validations.minimusCurrentDayStart')
            setErrors(prev => ({
                ...prev,
                from: errorMessage
            }))
        } else {
            setModal(prev => ({
                ...prev,
                open: true,
                confirm: () => {
                    keepSaveSchedule()
                    closeModal()
                }
            }))
        }

    }

    useEffect(() => {

        if (flag) {
            setFlag(false)
        } else {
            setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
            //reiniciar todos los campos
            setData(prev => ({
                ...prev, from: null, to: null, startDateDaily: null, endDateDaily: null,
                fromDateDaily: null, toDateDaily: null, fromDateCycli: null, toDateCycli: null, startDate: null,
                duration: null, endDate: null, dayOfWeek: null, fromDateWeekly: null, toDateWeekly: null, durationCycli: null
            }))
            setStartDate(undefined)
        }

    }, [data.frequency])


    useEffect(() => {
        const newDaysOfWeek = daysOfWeek.filter(day => selectedDays.includes(day.value))
        setInputSecondWeekly(prev => ({ ...prev, dayOfWeek: { ...prev.dayOfWeek, items: newDaysOfWeek } }))
    }, [selectedDays])

    useEffect(() => {
        onChange({ target: { name: 'days', value: '1' } })
    }, [selectedDays])

    const typeScheduling = useMemo(() => itemTypeScheduling({ t }), [])
    return (
        <Drawer
            PaperProps={{
                sx: { width: '530px', padding: '20px'/* , maxWidth: '320px' */ },
            }}
            anchor={'right'}
            open={open}
        /* onClose={toggleDrawer(anchor, false)} */
        >
            <Box sx={styles.flexGp2}>
                <Typography variant="text_grey" fontWeight={'bold'} fontSize={18}>{t('schedule.assigned.schedulingPlanning')}</Typography>

                {
                    userSelectes.id != 'all' && (
                        <Box sx={styles.flex}>
                            <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('useScheduled.referenceStore')}</Typography>
                            <MultiSelectSimple
                                label={t('general.tags.idStore')}
                                name='store'
                                selected={data?.store || null}
                                onChange={onChange}
                                loading={loadings.store}
                                items={items.stores}
                            />
                        </Box>
                    )
                }


                <Box sx={[styles.flex, styles.notifications]}>
                    <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('schedule.assigned.notification')}</Typography>

                    <Box>
                        <FormControlLabel
                            control={
                                <IOSSwitch
                                    name="notifiedAdmin"
                                    checked={!!data.notifiedAdmin}
                                    onChange={({ target }) => {
                                        onChange({
                                            target: {
                                                name: target.name,
                                                value: target.checked,
                                            },
                                        })
                                    }}
                                    sx={{ m: 1 }}
                                />
                            }
                            label={t('schedule.assigned.sendAlertToAdminSecond')}
                        />
                    </Box>

                    <Box>
                        <FormControlLabel
                            control={
                                <IOSSwitch
                                    name="notified"
                                    checked={!!data.notified}
                                    onChange={({ target }) => {
                                        onChange({
                                            target: {
                                                name: target.name,
                                                value: target.checked,
                                            },
                                        })
                                    }}
                                    sx={{ m: 1 }}
                                />
                            }
                            label={t('schedule.assigned.sendAlertSecond')}
                        />
                    </Box>
                </Box>

                <Box sx={styles.flex}>
                    <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('schedule.assigned.schedulingType')}</Typography>
                    <SelectActionPlan
                        value={!!data.openQuestionnaire}
                        onChange={(_, value) => {
                            onChange({
                                target: {
                                    name: 'openQuestionnaire',
                                    value: value,
                                },
                            })
                        }}
                        items={typeScheduling}
                        width={100}
                        widthVariable
                    />
                </Box>

                {!data?.openQuestionnaire &&
                    <>
                        <Box sx={styles.flex}>
                            <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('schedule.assigned.frequency')}</Typography>

                            <CustomSelect items={frequencies} name="frequency" label={`${t('schedule.scheduleType')} *`} selected={data.frequency} onChange={onChange} errors={errors} isRequired />

                            {data.frequency == FrequencyEnum.DAYLI &&
                                <Box sx={styles.containerIcon}>
                                    <Typography>{icons('error')}</Typography>
                                    <Typography>{t('schedule.assigned.frecuencyDailyDescription')}</Typography>
                                </Box>
                            }
                        </Box>

                        <Box sx={styles.flex}>
                            <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{data.frequency == FrequencyEnum.UNIQUE ? t('schedule.assigned.availabilitySchedule') : t('schedule.assigned.availabilityByCalendar')}</Typography>

                            {getFrecuencyInputs()}
                        </Box></>
                }

                {
                    userSelectes.id != 'all' && (
                        <Box sx={styles.flex}>
                            <Box sx={styles.flexAlign}>
                                <MapMarker />
                                <Typography variant="text_grey" fontWeight={'bold'} fontSize={16}>{t('useScheduled.referenceOrigynStore')}</Typography>
                            </Box>
                            <MultiSelectSimple
                                label={t('general.tags.idStore')}
                                name='originStoreId'
                                selected={data?.originStoreId || null}
                                onChange={onChange}
                                items={items.storesAll}
                            />
                            <Typography variant="text_grey">{t('useScheduled.textOrigynStore')}</Typography>
                        </Box>
                    )
                }
            </Box>

            <SimpleModal
                open={!!modal.open}
                next={modal?.confirm}
                back={closeModal}
                close={closeModal}
                buttonText={t('general.save')}
                cancelText={t('general.cancel')}
                title={t('schedule.modal.confirmation')}
                sx={{ width: '470px' }}
                children={
                    <Box sx={styles.containerChild}>
                        <Typography className="title_text" /* variant='text_grey' */ fontSize={14}>{modal.description}</Typography>
                        <Box >

                            {children.map((child, index) => (
                                <Box sx={{ display: 'flex' }}>
                                    <Box sx={styles.containerCircle}>
                                        <Box sx={styles.circle} />
                                    </Box>

                                    <Typography sx={styles.textList} fontSize={14}>
                                        {child}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                }
            />

            <Box sx={styles.containerChildButtons}>
                <Button
                    disabled={disabled()}
                    sx={styles.aceptButton}
                    onClick={() => {
                        assignedChildren()
                    }}
                    variant='contained'
                >{t(`useScheduled.detail.buttons.apply`)}</Button>

                <Button
                    onClick={() => {
                        handleCloseScheduleUser()
                    }}
                    sx={styles.cancelButton}
                >{t('useScheduled.detail.buttons.cancel')}</Button>
            </Box>
        </Drawer>

    )
}

export { UserScheduleConfig }
